module.exports = __webpack_public_path__ + "img/douyin2.366ad3a4.svg";